import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const CANDIDATES_DATA = [
  { id: 1, name: 'Yaw Mensah', role: 'Operations Manager', location: 'Kumasi, Ghana', skills: ['Logistics', 'Supply Chain', 'Team Leadership'] },
  { id: 2, name: 'Ama Serwaa', role: 'Frontend Developer', location: 'Accra, Ghana', skills: ['React', 'Tailwind CSS', 'TypeScript'] },
  { id: 3, name: 'Ekow Thompson', role: 'Sales Executive', location: 'Takoradi, Ghana', skills: ['Negotiation', 'B2B Sales', 'CRM'] },
  { id: 4, name: 'Linda Ofori', role: 'Human Resource Specialist', location: 'Accra, Ghana', skills: ['Recruitment', 'Employee Relations', 'Payroll'] },
  { id: 5, name: 'David Tetteh', role: 'Data Analyst', location: 'Cape Coast, Ghana', skills: ['SQL', 'Python', 'Power BI'] },
  { id: 6, name: 'Grace Asante', role: 'UI Designer', location: 'Remote', skills: ['Figma', 'Prototyping', 'Visual Design'] },
];

const Candidates = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const filteredCandidates = CANDIDATES_DATA.filter(c => {
    const searchLower = searchTerm.toLowerCase();
    return (
      c.name.toLowerCase().includes(searchLower) ||
      c.role.toLowerCase().includes(searchLower) ||
      c.skills.some(s => s.toLowerCase().includes(searchLower))
    );
  });

  const handleExportCSV = () => {
    // Define CSV headers
    const headers = ['ID', 'Name', 'Role', 'Location', 'Skills'];
    
    // Convert filtered candidate data to CSV format
    const csvData = filteredCandidates.map(c => 
      [
        c.id, 
        `"${c.name}"`, 
        `"${c.role}"`, 
        `"${c.location}"`, 
        `"${c.skills.join(', ')}"`
      ].join(',')
    );
    
    // Combine headers and data
    const csvContent = [headers.join(','), ...csvData].join('\n');
    
    // Create blob and download link
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'candidates_export.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Candidates</h1>
          <p className="text-gray-500">Browse and filter through your talent pool.</p>
        </div>
        <button 
          onClick={handleExportCSV}
          className="px-5 py-2.5 bg-[#11469A] hover:bg-[#0d3678] text-white rounded-lg transition-all shadow-md flex items-center gap-2 font-bold text-sm uppercase tracking-wider"
        >
          <SafeIcon name="Download" size={18} /> Export CSV
        </button>
      </div>

      <div className="card p-4 shadow-sm border border-gray-100">
        <div className="relative w-full">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400">
            <SafeIcon name="Search" size={18} />
          </div>
          <input 
            type="text" 
            placeholder="Search by name, role, or skills..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-12 pr-4 h-12 rounded-lg border border-gray-200 focus:border-[#11469A] transition-all outline-none bg-white" 
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredCandidates.length > 0 ? (
          filteredCandidates.map((candidate) => (
            <div key={candidate.id} className="card p-6 border border-gray-100 bg-white shadow-sm hover:shadow-md transition-all duration-300 text-left flex flex-col">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-1">{candidate.name}</h3>
                  <p className="text-sm text-[#11469A] font-bold">{candidate.role}</p>
                </div>
                <button className="flex items-center gap-1.5 px-3 py-1.5 text-[11px] font-bold text-gray-600 bg-gray-100 hover:bg-gray-200 rounded transition-colors uppercase tracking-wider">
                  <SafeIcon name="FileText" size={14} /> Resume
                </button>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-500 mb-5">
                <SafeIcon name="MapPin" size={16} className="text-gray-400" /> {candidate.location}
              </div>
              <div className="space-y-3 mb-6">
                <div className="flex flex-wrap gap-2">
                  {candidate.skills.map((skill, idx) => (
                    <span key={idx} className="px-2.5 py-1 rounded bg-gray-50 border border-gray-100 text-gray-600 text-[10px] font-bold uppercase tracking-wider">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
              <button 
                onClick={() => navigate(`/candidates/${candidate.id}`)} 
                className="w-full py-2.5 bg-[#11469A] hover:bg-[#0d3678] text-white font-bold rounded shadow-sm transition-all text-xs uppercase tracking-widest mt-auto"
              >
                View Full Profile
              </button>
            </div>
          ))
        ) : (
          <div className="col-span-1 md:col-span-2 lg:col-span-3 text-center py-12 text-gray-500 bg-white rounded-xl border border-gray-100">
            No candidates found matching '{searchTerm}'.
          </div>
        )}
      </div>
    </div>
  );
};

export default Candidates;